import { useDocumentsApi } from '../../infrastructure/api/useDocumentsApi'
import { Document } from '../../domain/documents.types'

export const useDocumentUseCase = () => {
  const {
    downloadFile,
    downloadFiles,
    getBlob,
    getDocumentListByPlantWithCount,
    getDocumentListByUserWithCount,
  } = useDocumentsApi()
  return {
    getDocumentListByUserWithCount: async (
      options: { pageIndex: number; pageSize: number },
      search: string | null,
      sorting: { id: string; desc: boolean }[]
    ) => {
      return getDocumentListByUserWithCount(options, search, sorting)
    },
    getDocumentListByPlantWithCount: async (
      plantId: number,
      options: {
        pageIndex: number
        pageSize: number
      },
      search: string | null,
      sorting: { id: string; desc: boolean }[]
    ) => {
      return getDocumentListByPlantWithCount(plantId, options, search, sorting)
    },
    getBlob: async (blobId: string) => {
      return getBlob(blobId)
    },
    downloadFile: async (file: Document) => {
      return downloadFile(file)
    },
    downloadFiles: async (documentsId: string[]) => {
      return downloadFiles(documentsId)
    },
  }
}
